import unregisterReducer from './unregister-reducer';

export default unregisterReducer;